<template>
  <div id="supplier" class="q-pa-md">
    <q-form id="queryForm" :model="queryForm" @submit="query" @reset="reset">
      <div class="row q-gutter-md justify-center">
        <div class="col-12 corner">
          <q-btn
            color="primary"
            id="addBtn"
            @click="toAddSupplier"
            label="添加供应商"
            icon="person"
          />
        </div>
        <div class="col-md-3 col-11">
          <q-input
            filled
            v-model="queryForm.supplierName"
            label="供应商名称"
            dense
            clearable
          />
        </div>
        <div class="col-md-3 col-11">
          <q-btn label="查询" type="submit" color="primary" />
          <q-btn
            label="重置"
            type="reset"
            color="primary"
            flat
            class="q-ml-sm"
          />
        </div>
      </div>
    </q-form>

    <q-table
      ref="mytable"
      title="供应商信息"
      :data="tableData.list"
      :columns="columns"
      row-key="id"
      :pagination.sync="pagination"
      :loading="loading"
      @request="request"
      binary-state-sort
      separator="cell"
      :rows-per-page-options="[10, 20, 50, 0]"
    >
      <template v-slot:body-cell-opt="props">
        <q-td>
          <div class="q-px-md q-gutter-sm" style="text-align:center">
            <q-btn
              round
              color="primary"
              size="xs"
              icon="edit"
              @click="handleEdit(props.rowIndex, props.row)"
            />
            <q-btn
              round
              color="deep-orange"
              size="xs"
              icon="delete_forever"
              @click="handleRemove(props.row)"
            />
          </div>
        </q-td>
      </template>
    </q-table>
  </div>
</template>

<script>
import { list,remove } from "@/api/erp/supplier";
export default {
  data() {
    return {
      queryForm: {},
      tableData: {},
      loading: false,
      pagination: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      },
      columns: [
        {
          name: "supplierName",
          align: "center",
          label: "供应商名称",
          field: "supplierName",
        },
        {
          name: "supplierShortName",
          align: "center",
          label: "供应商简称",
          field: "supplierShortName",
        },
        {
          name: "mainBusiness",
          align: "center",
          label: "主营业务",
          field: "mainBusiness",
        },
        {
          name: "taxNo",
          align: "center",
          label: "税号",
          field: "taxNo",
          sortable: true,
        },
        {
          name: "address",
          align: "center",
          label: "地址",
          field: "address",
        },
        {
          name: "telephone",
          align: "center",
          label: "电话",
          field: "telephone",
          sortable: true,
        },
        {
          name: "openBank",
          align: "center",
          label: "开户行",
          field: "openBank",
          sortable: true,
        },
        {
          name: "account",
          align: "center",
          label: "帐号",
          field: "account",
          sortable: true,
        },
        {
          name: "bankNo",
          align: "center",
          label: "行号",
          field: "bankNo",
          sortable: true,
        },
        {
          name: "contact",
          align: "center",
          label: "联系人",
          field: "contact",
        },
        {
          name: "opt",
          align: "center",
          label: "操作",
          field: "opt",
        },
      ],
    };
  },
  methods: {
    query() {
      this.$refs.mytable.requestServerInteraction();
    },
    reset() {
      this.queryForm = {};
      this.pagination = {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      };
      this.query();
    },
    toAddSupplier() {
      this.$router.push("/supplier/detail");
    },
    request(props) {
      this.loading = true;
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      var self = this;
      self.queryForm.pageNum = page;
      self.queryForm.pageSize = rowsPerPage;
      list(self.queryForm).then(function (response) {
        if (response.data.errorCode == "00000") {
          self.tableData = response.data.data;
          self.pagination.rowsNumber = self.tableData.total;
          // don't forget to update local pagination object
          self.pagination.page = page;
          self.pagination.rowsPerPage = rowsPerPage;
          self.pagination.sortBy = sortBy;
          self.pagination.descending = descending;
          // ...and turn of loading indicator
          self.loading = false;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    handleEdit(rowIndex, row) {
      this.$router.push({ path: "/supplier/detail", query: { id: row.id } });
    },
    handleRemove(row) {
      var self = this;
      this.$q
        .dialog({
          title: "请谨慎操作",
          message: "此操作将永久删除该条记录, 是否继续?",
          cancel: "取消",
          ok: "确定",
          persistent: true,
        })
        .onOk(() => {
          console.log(">>>> OK");
          remove(row.id).then(function (response) {
            if (response.data.errorCode == "00000") {
              self.$q.notify({ type: "positive", message: "删除成功" });
              self.query();
            } else {
              self.$q.notify({
                type: "negative",
                message: response.data.errorMsg,
              });
            }
          });
        })
        .onCancel(() => {
          self.$q.notify({ type: "info", message: "已取消删除" });
        })
        .onDismiss(() => {
          console.log("I am triggered on both OK and Cancel");
        });
    },
  },
  mounted: function () {
    this.query();
  },
};
</script>

<style scoped>
.corner {
  flex-direction: row-reverse;
  display: flex;
}
#queryForm {
  /* margin-top: 20px; */
  margin-bottom: 20px;
}
</style>